import Spinner from "./Spinner";
export default function LoadingPage(props) {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <Spinner />
    </div>
  );
}
